import { MaintenanceTaskInterface } from "module/maintenanceTask/types";
import { supportedTypes } from "module/maintenanceTask/helper/supportedTypes";

export const canProcess = (
  maintenanceTask: MaintenanceTaskInterface
): boolean => supportedTypes.includes(maintenanceTask.type);
